<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>结算订单[{{ kaidan_title }}]</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <div class="kaidan_body">
                <div style="width: 150px; min-width: 150px;" v-if="true">
                    <el-steps :active="cardShow - 1" align-center direction="vertical">
                        <el-step title="质检验收" description="车辆信息" @click.native="menu_set(1)"
                            v-if="singleFlag !== '1'"></el-step>
                        <el-step title="服务订单确认" description="服务单信息" @click.native="menu_set(2)"
                            v-if="singleFlag !== '1'"></el-step>
                        <el-step title="销售订单确认" description="订单信息" @click.native="menu_set(3)"></el-step>
                        <el-step title="支付账单" description="支付账单" @click.native="menu_set(4)"></el-step>

                    </el-steps>
                </div>
                <div style="width: 100%;" class="kaidan">
                    <div class="kaidan">
                        <el-card v-if="cardShow_xianshi === 1" class="card_style">
                            <div v-if="cardShow_sub === 1"> <el-form ref="paizhaoRef" :model="queryInfoChepai"
                                    :rules="paizhaoRules" label-width="100px">
                                    <el-form-item label="车辆牌照：" prop="paizhao" style="font-size: 30px;">
                                        <el-input v-model="queryInfoChepai.paizhao" placeholder="请输入车牌"
                                            style="font-size: larger;"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>

                        </el-card>
                        <el-card v-if="cardShow_xianshi === 2" class="card_style">
                            <div v-if="cardShow_sub === 1">
                                <!-- 开单调用 ，在此处车辆添加，无需通过响应事件返回数据，直接由回调返回-->
                                <orderList ref="orderListRef" :paizhao="queryInfoChepai.paizhao" :caozuo_type="0"
                                    @get_order_selected_uid="get_order_selected_uid" :query_flag="0" :select_flag="1">
                                </orderList>
                            </div>

                        </el-card>
                        <el-card v-if="cardShow_xianshi === 3" class="card_style">
                            <!-- 外观只需要添加，无需在此修改 所以 caozuoType 1   diaoyongType 2-开单-->
                            <div v-if="cardShow_sub === 1">
                                <div v-for="(item, index) in arrayOrderUidSelected" :key="index">
                                    <Func ref="FuncRef" :orderInfo="item" show_type="cheliang_info" :diaoyongType="3">
                                    </Func>
                                </div>
                            </div>

                        </el-card>
                        <el-card v-if="cardShow_xianshi === 4" class="card_style">
                            <!-- 外观只需要添加，无需在此修改 所以 caozuoType 1   diaoyongType 2-开单-->

                            <div v-if="cardShow_sub === 1" style="height: 600px;text-align: center;margin-top: 100px;">
                                <!-- 直接通过回调函数获取客户信息，无需通过事件响应 -->
                                <span style="font-size: 36px;"> 合计剩余需支付费用: </span><span
                                    style="font-size: 36px;color:red;">
                                    {{ payInfo.order_money_shengyu }} </span><span style="font-size: 36px;"> 元 </span>
                            </div>
                            <div v-if="cardShow_sub === 2">
                                <div style="height: 100%;text-align: center;margin-top: 100px;">
                                    <img :src="picShoukuanma" alt="" style="width: 400px;height: 400px;">

                                </div>
                            </div>
                            <div v-if="cardShow_sub === 3">
                                <div v-for="(item, index) in arrayOrderUidSelected" :key="index">
                                    <Func ref="FuncRef" :orderInfo="item" show_type="cheliang_info" :diaoyongType="4">
                                    </Func>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
        </el-card>
        <div style="margin-top: 10px;text-align: center;"><span slot="footer" class="dialog-footer">
                <el-button @click="quxiao">取 消</el-button>
                <el-button type="primary" @click="addorder" :disabled="add_isDisable">{{ button_text
                    }}</el-button>
            </span> </div>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../config/validator';
// import picUpload from '../pic_com.vue'
import orderList from './order_list.vue'
import Func from './func.vue'

export default {
    props: ['jiesuanSingleOrderInfo', 'singleFlag'],
    // jiesuanSingleOrderInfo 结算的订单信息 singleFlag 单行选择标记 1 单行选择 2 独立多行选择
    components: {
        orderList: orderList,
        Func: Func
        // picUpload: picUpload
    },
    data() {
        return {
            picShoukuanma: '',
            orderMoneySum: 0,
            arrayOrderUidSelected: [],
            errFlag: 0,
            datekey: Date.now(),
            // editUid_cheliang: 0, // 修改uid
            car_update_flag: 0, // 是否为新添加 车辆资料 1 新车型 2 已有车型
            guest_update_flag: 0, // 是否为新添加客户， 1位新客户 2为已有客户
            array_cardShow_sub: [],
            kaidan_title: '0',
            button_text: '下一步',
            isCollapse002: true,
            cardShow: 1, // 主模块控制标记
            cardShow_sub: 1, // 子元素显示标记
            cardShow_xianshi: 1, // 用于显示
            isCollapse: true,
            order_options: [
                {
                    value: 1,
                    label: '初级订单'
                },
                {
                    value: 2,
                    label: '中级订单'
                },
                {
                    value: 3,
                    label: '高级订单'
                }
            ],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'order_list',
                query: '',
                pageNum: 1,
                pageSize: 10,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            queryInfoChepai: {
                C_type: 'query_paizhao',
                paizhao: ''
                // qiye_uid: window.sessionStorage.getItem('qiye_uid') // 车牌信息通用，可以不用企业标识
            },

            waiGuanAddForm: {
                bianhao: '',
                waiguan_memo: '',
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            queryInfoGuestMob: {
                C_type: 'query_guestMob',
                guestMob: '',
                qiye_uid: window.sessionStorage.getItem('qiye_uid') // 客户查询信息通用，可以不用企业标识
            },

            huifang_isDisable: false,
            add_isDisable: false,
            orderList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            huifangDialogVisible: false,

            // 用于设置回访页面滑块值
            //  添加表单数据项
            huifangForm: {
                C_type: 'huifang_add',
                huifang_order_uid: 0,
                huifang_title: '',
                hufiang_memo: '',
                huifang_genjin: 1,
                huifang_yuangong_uid: 0,
                huifang_switch: true
            },
            addFormInit: {
                // 在每个业务流程中，都保存每个业务的重要数据
                C_type: 'order_add',
                kaidanFlag: 1, // 用于传递 到出库页面 ，区别仓库出库功能
                order_bianhao: '',
                // *****选择获得*******
                cheliang_uid: 0,
                guest_uid: 0,
                waiguan_uid: 0,
                chukudan_uid: 0,
                // ************
                cheliang_info: {},
                guest_info: {},
                waiguan_info: {},
                chukudan_info: {},
                order_info: {}
            },
            addForm: {
                // 在每个业务流程中，都保存每个业务的重要数据
                C_type: 'order_add',
                order_bianhao: '',
                // *****选择获得*******
                cheliang_uid: 0,
                guest_uid: 0,
                waiguan_uid: 0,
                chukudan_uid: 0,
                // ************
                cheliang_info: {},
                guest_info: {},
                waiguan_info: {},
                chukudan_info: {},
                order_info: {}
            },
            // 表单规则项
            guestMobTestRefRules: {
                guestMob: [
                    {
                        validator: checkMobileTest.bind(
                            this.queryInfoGuestMob && this.queryInfoGuestMob.guestMob
                        )
                    }
                    // { required: true, message: '请输入手机号码', trigger: 'blur' },
                    // { min: 11, max: 11, message: '必须是11位字符! ', trigger: 'blur' }
                ]
            },
            paizhaoRules: {
                paizhao: [
                    { required: true, message: '请输入牌照', trigger: 'blur' },
                    { min: 7, max: 8, message: '必须是6-7位字符! ', trigger: 'blur' }
                ]
            },
            addFormRules: {
                order_name: [
                    { required: true, message: '请输入订单名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ],

                order_mob: [
                    {
                        validator: checkMobileTest.bind(
                            this.addForm && this.addForm.order_mob
                        )
                    }
                ],
                order_sfz_bianhao: [
                    {
                        validator: checkSfzId.bind(
                            this.addForm && this.addForm.order_sfz_bianhao
                        )
                    }
                ]
            },
            editCheliangRules: {},
            huifangFormRefRules: {
                huifang_title: [
                    { required: true, message: '请输入回访标题', trigger: 'blur' },
                    { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
                ]
            },
            waiGuanAddFormRules: {},
            payInfo: {}
        };
    },
    created() {
        // this.getorderList();
        console.log('强制刷新')
        // this.getBianhao_order()
        // 直接赋值 订单uid ，无需输入车牌号码
        this.$nextTick()
        this.order_setUid_jiesuan()
    },
    mounted() {
        this.picShoukuanma = window.sessionStorage.getItem('picShoukuanma')
        this.picShoukuanma = this.picShoukuanma.slice(0, this.picShoukuanma.length - 1)
        console.log('picShoukuanma', this.picShoukuanma)
    },
    methods: {
        backPicUrl(pics) {
            if (this.addDialogVisible === true) {
                this.addForm.pics = pics
                this.pics = pics
            }

            if (this.editDialogVisible === true) {
                this.editForm.pics = pics
                this.pics = pics
            }
        },
        get_order_selected_uid(data) {
            console.log('array_order_uid_selected', data)
            this.arrayOrderUidSelected = data
        },
        menu_set(type) {
            console.log(9876, type)
            if (this.cardShow >= type) {
                this.kaidan_title_set(type)
                this.cardShow_xianshi = type
                this.cardShow = type
                this.cardShow_sub = 1
            }
        },
        quxiao() {
            if (this.singleFlag === '1') this.menu_set(3)
            else this.menu_set(1)
            this.$emit('jiesuan_addClose', 0)
        },
        async getBianhao_waiguan() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 15 }
            });
            this.waiGuanAddForm.bianhao = JSON.parse(res.data)[0].bianhao_l;
        },
        async getBianhao_order() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 16 }
            });
            this.addForm.order_bianhao = JSON.parse(res.data)[0].bianhao_l;
            this.kaidan_title_set(1)
        },
        getCarTypeSelectedUid(uid) {
            console.log('chexingUid', uid)
            this.editCheliangForm.chexing_uid = uid
        },
        SelectType(type) {
            this.cheliangSelectType = type
        },
        getGuestInfo(data) {
            this.addForm.guest_uid = data.guestUid // 新添加的客户，要通过子组件上报获得,修改的车辆直接通过页面获得
            this.addForm.guest_info = data
        },
        getCheliangNewUid(CheliangNewUid) {
            // console.log(1000)
            // console.log('cheliangUid', CheliangNewUid)
            this.addForm.cheliang_uid = CheliangNewUid // 新添加的车辆，要通过子组件上报获得,修改的车辆直接通过页面获得
        },

        get_switch_value(switchValue) {
            this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
            console.log(this.huifangForm.huifang_genjin);
        },
        async huiFangAdd() {
            const { data: res } = await this.$http.post('api', this.huifangForm);
            console.log(JSON.parse(res.data)[0].bianhao_s);
            this.huifangDialogVisible = true;
        },
        async get_order_add() {
            this.cardShow = 1
            this.cardShow_xianshi = 1
            this.cardShow_sub = 1
            await this.getBianhao_order()
            this.kaidan_title_set()
            this.addDialogVisible = true;
        },
        async getorderList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data))
            this.orderList = JSON.parse(res.data)[0].dataList;

            if (!this.orderList) return;
            this.orderList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getorderList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getorderList();
        },
        kaidan_title_set(type) {
            console.log('当前位置', this.cardShow_xianshi, this.cardShow, this.cardShow_sub)
            if (type === 1) {
                this.cardShow_xianshi = this.cardShow
                this.array_cardShow_sub[this.cardShow - 1] = this.cardShow_sub
            }

            return 0
        },
        test_pro() {
            console.log(8888, this.cardShow_xianshi, this.cardShow, this.cardShow_sub, this.addForm)
        },
        err_chuli(type, data) {
            if (data.uid === -1) {
                this.$message.error(type === 1 ? '车辆添加出错' : type === 2 ? '外观添加出错' : '客户添加出错')
                return 0
            }
        },
        async order_setUid_jiesuan() {
            if (this.singleFlag === '1') {
                this.arrayOrderUidSelected = [this.jiesuanSingleOrderInfo]
                console.log(886, this.arrayOrderUidSelected)
                this.cardShow = 2
                this.cardShow_sub = 1
                this.addorder()
            }
        },
        async addorder() {
            this.add_isDisable = true
            setTimeout(() => {
                this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
            }, 1000)
            this.cardShow_xianshi = this.cardShow
            if ((this.cardShow === 1) && (this.cardShow_sub === 1)) {
                this.$refs.paizhaoRef.validate(async valid => {
                    if (!valid) return 1;
                    if (this.cardShow_sub === 1) {
                        const { data: res } = await this.$http.post('api', this.queryInfoChepai);
                        if (JSON.parse(res.data)[0].status === 201) { // 没有车辆，直接报错
                            this.$message.error('车辆信息有误，请重新输入！')
                            return 0
                            // this.cardShow_sub = 2 // 用于card显示哪个内容标记
                        } else if (JSON.parse(res.data)[0].status === 200) {
                            this.kaidan_title_set(2)
                            this.cardShow = 2
                            this.cardShow_xianshi = this.cardShow
                            this.cardShow_sub = 1
                        }
                        // this.kaidan_title_set(1)
                        // this.test_pro()
                    }
                })
                return 0
            }
            if ((this.cardShow === 2) && (this.cardShow_sub === 1)) {
                // 对已经选中的订单中的服务单进行质检处理
                // 弹框提示
                console.log(9191, this.arrayOrderUidSelected)
                if (this.arrayOrderUidSelected.length === 0) {
                    this.$message.error('请选择订单，再行操作')
                    return 0
                }
                if (this.singleFlag !== '1') {
                    const comfirmResult = await this.$confirm(
                        '一键确认所有选中订单中的服务单, 是否继续?',
                        '提示',
                        {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }
                    ).catch(err => err);
                    if (comfirmResult === 'cancel') return 0
                    // 处理订单中的服务运营单信息
                }

                this.orderMoneySum = 0
                this.arrayOrderUidSelected.forEach((item) => {
                    // 写每一个运营单
                    // 计算合计费用
                    this.orderMoneySum += item.order_money
                    console.log('test', item)
                    var updateSql = {
                        C_type: 'update_yy_status_flag',
                        order_uid: item.uid
                    }
                    const { data: res05 } = this.$http.post('api', updateSql)
                })
                this.cardShow = 3
                this.cardShow_xianshi = this.cardShow
                this.cardShow_sub = 1
                this.kaidan_title_set(3)
                this.test_pro()
                return 0
            }
            if ((this.cardShow === 3) && (this.cardShow_sub === 1)) {
                // 显示支付账单
                var errFlagPar = 0
                this.$refs.FuncRef[0].selectPayType((errFlag, data) => { // 通过data 回调 返回order_info 
                    console.log(9988, data)
                    errFlagPar = errFlag
                    this.payInfo = data // 获得返回数据
                })

                // 读取支付账单，并写入订单中的 数据项目
                //  order_jiesuan_type，order_money_dikou，order_money_shengyu
                if (errFlagPar === 1) return 0 // 有错误，就停下来等
                this.cardShow = 4
                this.cardShow_xianshi = this.cardShow
                this.cardShow_sub = 1
                this.kaidan_title_set(3)
                this.test_pro()
                return 0
            }
            if ((this.cardShow === 4) && (this.cardShow_sub === 1)) {
                // 生成二维码，用户扫码以后，自动显示确认成功，也可以直接取消，不结算
                this.cardShow_sub = 2

                return 0
            }
            if ((this.cardShow === 4) && (this.cardShow_sub === 2)) {
                // 转到付款，订单确认,订单状态确认 ，由func 回调反馈带回 426行
                const comfirmResult = await this.$confirm(
                    '确定客户已经付款，进入订单打印？',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).catch(err => err);
                if (comfirmResult === 'cancel') return 1
                var updateSql = {
                    C_type: 'order_pay_queren',
                    order_uid: this.payInfo.uid,
                    order_money: this.payInfo.order_money,
                    order_money_dikou: this.payInfo.order_money_dikou,
                    order_money_shengyu: this.payInfo.order_money_shengyu,
                    order_jiesuan_type: this.payInfo.order_jiesuan_type,
                    order_youhui: this.payInfo.order_youhui
                }
                const { data: res05 } = await this.$http.post('api', updateSql)
                if (JSON.parse(res05.data)[0].status === 203) {
                    this.$message.error('重复结算！');
                    return;
                }
                this.$message.success('订单确认结算成功');
                // this.input_init()
                // this.test_pro()
                // this.$emit('jiesuan_addClose', 0) // 发射事件关闭窗口
                this.cardShow_sub = 3
                return 0
            }
            if ((this.cardShow === 4) && (this.cardShow_sub === 3)) {
                // 转到付款，订单确认,订单状态确认 ，由func 回调反馈带回 426行
                this.input_init()
                this.order_setUid_jiesuan()
                this.test_pro()
                this.$emit('jiesuan_addClose', 0) // 发射事件关闭窗口
                return 0
            }
        },
        input_init() {
            this.cardShow = 1
            this.cardShow_xianshi = 1
            this.cardShow_sub = 1
            // this.editForm = {}
            this.addForm = this.addFormInit
        },
        async getCheliangInfo() {
        },
        showEditDialog(uid) {
            this.orderInfo(uid);
            this.editDialogVisible = true;
        },
        addDoalogClosed() {
            // this.$refs.addFormRef.resetFields();
            this.input_init()
        },
        huifangDoalogClosed() {
            this.$refs.huifangFormRef.resetFields();
        },
        showHuifangDialog(uid) {
            this.huifangDialogVisible = true;
            this.orderInfo(uid);
        },
        editDoalogClosed() {
            this.$refs.editFormRef.resetFields();
        },
        async orderInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'order_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            // console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }

            this.editForm = JSON.parse(res.data)[0].data[0];
            this.huifangForm.huifang_order_uid = JSON.parse(res.data)[0].data[0].uid;
        },
        async updateorder() {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return this.$message.error('验证错误！');
                this.editForm.C_type = 'order_update';
                // 对象加入一个项C_type
                const { data: res } = await this.$http.post('api', {
                    C_type: 'order_update',
                    order_bianhao: this.editForm.order_bianhao.trim(),
                    order_name: this.editForm.order_name,
                    order_mob: this.editForm.order_mob,
                    order_addr: this.editForm.order_addr,
                    order_sfz_bianhao: this.editForm.order_sfz_bianhao,
                    order_level: this.editForm.order_level,
                    order_price_want: this.editForm.order_price_want,
                    order_yixiang: this.editForm.order_yixiang,
                    order_memo: this.editForm.order_memo,
                    order_laiyuan: this.editForm.order_laiyuan,
                    order_uid: this.editForm.uid
                });

                if (JSON.parse(res.data)[0].status !== 200) {
                    this.$message.error('更新失败');
                    return;
                }
                this.$message.success('更新成功');
                this.getorderList();
                this.editDialogVisible = false;
            });
        },
        // 删除一条记录
        async deleteForm(orderUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            // console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'order_del',
                C_data1: orderUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getorderList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
    height: 650px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}

.kaidan {
    display: flex;
    flex-direction: column;

}

.card_style {
    height: 700px;
    overflow-y: auto;
}

.kaidan_title {
    background-color: #eee;
    width: 100%;
    height: 40px;
    font-size: 30px;
    color: black;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    padding-top: 8px;
}

.kaidan_body {
    display: flex;
    flex-direction: row;
    height: 700px;

}

.card_gundong {
    overflow-y: auto;
    max-height: 500px;
    max-width: 500px;
}
</style>
